var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-button-icon.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * This control is same as Button only with icon as trigger
 * and without capability to add nested element.
 *
 * @deprecated - Use `sds-button` instead
 */
let SdsButtonIcon = (() => {
    var _SdsButtonIcon_disabled_accessor_storage, _SdsButtonIcon_rounded_accessor_storage, _SdsButtonIcon_bordered_accessor_storage, _SdsButtonIcon_type_accessor_storage, _SdsButtonIcon_icon_accessor_storage, _SdsButtonIcon_hovered_accessor_storage, _SdsButtonIcon_clicked_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-button-icon')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _rounded_decorators;
    let _rounded_initializers = [];
    let _rounded_extraInitializers = [];
    let _bordered_decorators;
    let _bordered_initializers = [];
    let _bordered_extraInitializers = [];
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _hovered_decorators;
    let _hovered_initializers = [];
    let _hovered_extraInitializers = [];
    let _clicked_decorators;
    let _clicked_initializers = [];
    let _clicked_extraInitializers = [];
    let _set_size_decorators;
    var SdsButtonIcon = _classThis = class extends _classSuper {
        /**
         * True if disabled
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsButtonIcon_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsButtonIcon_disabled_accessor_storage, value, "f"); }
        /**
         * True if button is with rounded corners
         * @attr
         */
        get rounded() { return __classPrivateFieldGet(this, _SdsButtonIcon_rounded_accessor_storage, "f"); }
        set rounded(value) { __classPrivateFieldSet(this, _SdsButtonIcon_rounded_accessor_storage, value, "f"); }
        /**
         * True if button is with rounded corners
         * @attr
         */
        get bordered() { return __classPrivateFieldGet(this, _SdsButtonIcon_bordered_accessor_storage, "f"); }
        set bordered(value) { __classPrivateFieldSet(this, _SdsButtonIcon_bordered_accessor_storage, value, "f"); }
        /**
         * Button type
         * @attr
         */
        get type() { return __classPrivateFieldGet(this, _SdsButtonIcon_type_accessor_storage, "f"); }
        set type(value) { __classPrivateFieldSet(this, _SdsButtonIcon_type_accessor_storage, value, "f"); }
        /**
         * Icon to be Used, must be one of supported icons.
         * @attr
         */
        get icon() { return __classPrivateFieldGet(this, _SdsButtonIcon_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsButtonIcon_icon_accessor_storage, value, "f"); }
        get hovered() { return __classPrivateFieldGet(this, _SdsButtonIcon_hovered_accessor_storage, "f"); }
        set hovered(value) { __classPrivateFieldSet(this, _SdsButtonIcon_hovered_accessor_storage, value, "f"); }
        get clicked() { return __classPrivateFieldGet(this, _SdsButtonIcon_clicked_accessor_storage, "f"); }
        set clicked(value) { __classPrivateFieldSet(this, _SdsButtonIcon_clicked_accessor_storage, value, "f"); }
        constructor() {
            super();
            this._size = (__runInitializers(this, _instanceExtraInitializers), 'md');
            _SdsButtonIcon_disabled_accessor_storage.set(this, __runInitializers(this, _disabled_initializers, false));
            _SdsButtonIcon_rounded_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _rounded_initializers, false)));
            _SdsButtonIcon_bordered_accessor_storage.set(this, (__runInitializers(this, _rounded_extraInitializers), __runInitializers(this, _bordered_initializers, false)));
            _SdsButtonIcon_type_accessor_storage.set(this, (__runInitializers(this, _bordered_extraInitializers), __runInitializers(this, _type_initializers, 'tertiary')));
            _SdsButtonIcon_icon_accessor_storage.set(this, (__runInitializers(this, _type_extraInitializers), __runInitializers(this, _icon_initializers, '')));
            this._iconSize = (__runInitializers(this, _icon_extraInitializers), 24);
            _SdsButtonIcon_hovered_accessor_storage.set(this, __runInitializers(this, _hovered_initializers, false));
            _SdsButtonIcon_clicked_accessor_storage.set(this, (__runInitializers(this, _hovered_extraInitializers), __runInitializers(this, _clicked_initializers, false)));
            this.handleMouseDownEvent = (__runInitializers(this, _clicked_extraInitializers), () => {
                this.clicked = true;
            });
            this.handleMouseUpEvent = () => {
                this.clicked = false;
            };
            this.handleHoverEvent = () => {
                this.hovered = true;
            };
            this.handleLeaveEvent = () => {
                this.hovered = false;
            };
            this.disableClickWhenButtonIsDisabled();
        }
        get size() {
            return this._size;
        }
        /**
         * Size of the button
         * @attr
         */
        set size(value) {
            const oldValue = this._size;
            this._size = value;
            this.requestUpdate('size', oldValue);
            if (value === 'lg') {
                this._iconSize = 24;
            }
            if (value === 'md' || value === 'sm' || value === 'xs') {
                this._iconSize = 16;
            }
        }
        firstUpdated() {
            this.addEvents();
        }
        disconnectedCallback() {
            this.removeEvents();
        }
        render() {
            return html `
            <button class="${this.getClasses()}" .disabled="${this.disabled}">
                <sds-icon size="${this._iconSize}" name="${this.icon}"></sds-icon>
            </button>
        `;
        }
        disableClickWhenButtonIsDisabled() {
            this.addEventListener('click', event => {
                if (this.disabled) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    event.returnValue = false;
                }
            }, true);
        }
        addEvents() {
            this.addEventListener('mousedown', this.handleMouseDownEvent);
            this.addEventListener('mouseup', this.handleMouseUpEvent);
            this.addEventListener('mouseover', this.handleHoverEvent);
            this.addEventListener('mouseout', this.handleLeaveEvent);
        }
        removeEvents() {
            this.removeEventListener('mousedown', this.handleMouseDownEvent);
            this.removeEventListener('mouseup', this.handleMouseUpEvent);
            this.removeEventListener('mouseover', this.handleHoverEvent);
            this.removeEventListener('mouseout', this.handleLeaveEvent);
        }
        getClasses() {
            return classMap({
                'sds-button-icon': true,
                'sds-button-icon--tertiary': this.type == 'tertiary',
                'sds-button-icon--secondary': this.type == 'secondary',
                'sds-button-icon--danger': this.type == 'danger',
                'sds-button-icon--lg': this.size == 'lg',
                'sds-button-icon--md': this.size == 'md',
                'sds-button-icon--sm': this.size == 'sm',
                'sds-button-icon--xs': this.size == 'xs',
                'sds-button-icon--rounded': this.rounded,
                'sds-button-icon--disabled': this.disabled,
                'sds-button-icon--hovered': this.hovered,
                'sds-button-icon--active': this.clicked,
            });
        }
    };
    _SdsButtonIcon_disabled_accessor_storage = new WeakMap();
    _SdsButtonIcon_rounded_accessor_storage = new WeakMap();
    _SdsButtonIcon_bordered_accessor_storage = new WeakMap();
    _SdsButtonIcon_type_accessor_storage = new WeakMap();
    _SdsButtonIcon_icon_accessor_storage = new WeakMap();
    _SdsButtonIcon_hovered_accessor_storage = new WeakMap();
    _SdsButtonIcon_clicked_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsButtonIcon");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _disabled_decorators = [property({ type: Boolean })];
        _rounded_decorators = [property({ type: Boolean })];
        _bordered_decorators = [property({ type: Boolean })];
        _type_decorators = [property({ type: String })];
        _icon_decorators = [property({ type: String })];
        _hovered_decorators = [state()];
        _clicked_decorators = [state()];
        _set_size_decorators = [property()];
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _rounded_decorators, { kind: "accessor", name: "rounded", static: false, private: false, access: { has: obj => "rounded" in obj, get: obj => obj.rounded, set: (obj, value) => { obj.rounded = value; } }, metadata: _metadata }, _rounded_initializers, _rounded_extraInitializers);
        __esDecorate(_classThis, null, _bordered_decorators, { kind: "accessor", name: "bordered", static: false, private: false, access: { has: obj => "bordered" in obj, get: obj => obj.bordered, set: (obj, value) => { obj.bordered = value; } }, metadata: _metadata }, _bordered_initializers, _bordered_extraInitializers);
        __esDecorate(_classThis, null, _type_decorators, { kind: "accessor", name: "type", static: false, private: false, access: { has: obj => "type" in obj, get: obj => obj.type, set: (obj, value) => { obj.type = value; } }, metadata: _metadata }, _type_initializers, _type_extraInitializers);
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _hovered_decorators, { kind: "accessor", name: "hovered", static: false, private: false, access: { has: obj => "hovered" in obj, get: obj => obj.hovered, set: (obj, value) => { obj.hovered = value; } }, metadata: _metadata }, _hovered_initializers, _hovered_extraInitializers);
        __esDecorate(_classThis, null, _clicked_decorators, { kind: "accessor", name: "clicked", static: false, private: false, access: { has: obj => "clicked" in obj, get: obj => obj.clicked, set: (obj, value) => { obj.clicked = value; } }, metadata: _metadata }, _clicked_initializers, _clicked_extraInitializers);
        __esDecorate(_classThis, null, _set_size_decorators, { kind: "setter", name: "size", static: false, private: false, access: { has: obj => "size" in obj, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsButtonIcon = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsButtonIcon = _classThis;
})();
export { SdsButtonIcon };
